import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { CommanSubscribeService } from 'src/app/core/services/comman-subscribe.service';

@Component({
  selector: 'app-confirmation-dialog',
  templateUrl: './confirmation-dialog.component.html',
  styleUrls: ['./confirmation-dialog.component.scss']
})
export class ConfirmationDialogComponent  {

  title: string = "Are you sure you want to delete ?";
  ok: boolean = false;
  isClose: boolean = false;
  eventId: any;
  eventName: any;
  orgId: any;
  settingsData:any;

  constructor(public dialogRef: MatDialogRef<ConfirmationDialogComponent>,private commonSubscribeService: CommanSubscribeService,private router: Router,
    @Inject(MAT_DIALOG_DATA) private _data: any) {
      if(_data && _data.title) {
        this.title = _data.title;
      }
      if (_data.ok) {
        this.ok = true;
      }
      if(_data.isClose) {
        this.isClose = _data.isClose;
      }

      if(_data.eventId) {
        this.eventId = _data.eventId;
      }

      if(_data.eventName) {
        this.eventName = _data.eventName;
      }

      if(_data.orgId) {
        this.orgId = _data.orgId;
      }

      if(_data?.settingsData){
        this.settingsData =_data.settingsData
      }
  }

  close(type): void {
    const status = type === "yes" ? "Not Cancelled" : "Cancelled";
    const userId = this.commonSubscribeService.userInfo?.user_first_name + ' ' + this.commonSubscribeService.userInfo?.user_last_name;
    const albumId = this.commonSubscribeService.extractIdFromUrl(this.router.url);
    (window as any).umami?.track(`Proceeding to channel_sub/ticket_buy is ${status} - ${userId}`)
    const data = {
      actionType: "network",
      metaData: {
          title: `Proceeding to channel_sub/ticket_buy is ${status}`,
          eventId: this.eventId,
          eventName: this.eventName,
          orgId: this.orgId,
          timeStamp: new Date().toISOString()
      },
      organizationId: this.commonSubscribeService.slugInfo?.organization_id || null,
      clickAction:'subscribe',
      
    }
    this.commonSubscribeService.sendTriggeredEvent(data);
    // if(type === "no"){

    // }
    this.dialogRef.close(type);
  }

}
